import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Typography, Button } from '@mui/material';
import { useState } from 'react';

const NoResponsesAvailableYet = ({ onRefresh }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleManualRefresh = async () => {
    setIsRefreshing(true);

    if (onRefresh) {
      await onRefresh();
    }

    setTimeout(() => setIsRefreshing(false), 500);
  };

  return (
    <Box
      sx={{
        height: 'calc(100vh - 450px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px dashed #e0e0e0',
        borderRadius: 2,
        backgroundColor: '#fafafa',
        padding: 4
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2
        }}
      >
        <Typography sx={{ fontSize: 32, color: '#9e9e9e' }}>📊</Typography>
      </Box>

      {/* Main message */}
      <Typography
        variant='h6'
        sx={{
          fontWeight: 'bold',
          color: '#424242',
          mb: 1,
          textAlign: 'center'
        }}
      >
        No responses yet
      </Typography>

      {/* Explanatory text */}
      <Typography
        variant='body1'
        sx={{
          color: '#757575',
          textAlign: 'center',
          maxWidth: 400,
          lineHeight: 1.6,
          mb: 2
        }}
      >
        Responses will appear here once participants start submitting.
      </Typography>

      {/* Manual refresh button */}
      <Button
        variant='outlined'
        startIcon={<RefreshIcon sx={{ animation: isRefreshing ? 'spin 1s linear infinite' : 'none' }} />}
        onClick={handleManualRefresh}
        disabled={isRefreshing}
        sx={{
          textTransform: 'none',
          borderColor: '#e0e0e0',
          color: '#757575',
          mt: 3,
          '&:hover': {
            borderColor: '#1976d2',
            color: '#1976d2',
            backgroundColor: 'transparent'
          },
          '&:disabled': {
            borderColor: '#e0e0e0',
            color: '#bdbdbd'
          }
        }}
      >
        {isRefreshing ? 'Checking...' : 'Check for new responses'}
      </Button>

      {/* Add spinning animation for refresh icon */}
      <style jsx>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </Box>
  );
};

export default NoResponsesAvailableYet;
